const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)'

/** Points `#favicon` at the icon for the OS colour scheme, and follows later scheme changes. */
export const syncFaviconWithColorScheme = () => {
  const favicon = document.getElementById('favicon')
  if (!(favicon instanceof HTMLLinkElement)) return

  const showIconFor = (isDarkScheme: boolean) => {
    favicon.href = isDarkScheme ? '/favicon_light.png' : '/favicon.png'
  }
  const darkScheme = window.matchMedia(DARK_SCHEME_QUERY)
  showIconFor(darkScheme.matches)
  darkScheme.addEventListener('change', event => showIconFor(event.matches))
}
